import { render, staticRenderFns } from "./LotteryRules.vue?vue&type=template&id=020f637d&scoped=true&"
import script from "./LotteryRules.vue?vue&type=script&lang=js&"
export * from "./LotteryRules.vue?vue&type=script&lang=js&"
import style0 from "./LotteryRules.vue?vue&type=style&index=0&id=020f637d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "020f637d",
  null
  
)

export default component.exports